import { Controller } from "@hotwired/stimulus"
import { isMobileScreen, canHover } from '../helpers/media_helpers'
import { animateCollapse } from '../helpers/animation_helpers'

export default class extends Controller {
  static targets = ['button', 'links', 'animation']

  #closing = false

  toggleOnTap() {
    if (canHover()) return

    this.toggle()
  }

  toggle() {
    this.#isOpen ? this.close() : this.open()
  }

  closeOnClickOutside({ target }) {
    if (!this.#isOpen || isMobileScreen()) return

    for (const elem of [this.buttonTarget, this.linksTarget]) {
      if (elem.contains(target)) return
    }

    this.close()
  }

  open() {
    if (this.#isOpen) return

    this.buttonTarget.setAttribute('aria-expanded', 'true')
    this.linksTarget.setAttribute('aria-hidden', 'false')

    this.#animate(0, this.animationTarget.offsetHeight)
  }

  async close() {
    if (!this.#isOpen || this.#closing) return

    this.#closing = true

    await this.#animate(this.animationTarget.offsetHeight, 0)
    this.buttonTarget.setAttribute('aria-expanded', 'false')
    this.linksTarget.setAttribute('aria-hidden', 'true')

    this.#closing = false
  }

  async #animate(from, to) {
    if (canHover()) return

    await animateCollapse(this.animationTarget, from, to)
  }

  get #isOpen() {
    return this.linksTarget.getAttribute('aria-hidden') === 'false'
  }
}
